module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./checkboxBtn.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./checkboxBtn.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/checkboxBtn.vue
 ** module id = 95
 ** module chunks = 0
 **/